import React, { useState, useCallback } from 'react';
import axios from 'axios';
import { Button, Modal, Spin, Pagination, message } from 'antd';
import { useConfigQuery } from '../../../../queries/useConfig';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faSignOutAlt, faPlus, faSyncAlt } from '@fortawesome/free-solid-svg-icons';
import FormularioDeCadastroFiscal from './FormularioDeCadastroFiscal';
import axiosInstance from '../../../../axiosInterceptor';
import { api } from '../../../../config/api';

const CadastroFiscal = ({ closeModal }) => {
  const { data: config } = useConfigQuery();

  const [searchTerm, setSearchTerm] = useState('');
  const [cadastros, setCadastros] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  const [isModalVisible, setIsModalVisible] = useState(false);
  const [cadastroSelecionado, setCadastroSelecionado] = useState(null);

  const [currentPage, setCurrentPage] = useState(0);
  const [totalPages, setTotalPages] = useState(0);
  const [totalElements, setTotalElements] = useState(0);

  const accessToken = window.localStorage.getItem("accessToken");

  // ==================== BUSCA COM PAGINAÇÃO ====================
  const loadCadastros = useCallback(async (page = 0) => {
    if (!accessToken || !config?.idLoja) return;

    setIsLoading(true);
    setCurrentPage(page);

    try {
      const params = new URLSearchParams();
      if (searchTerm.trim()) params.append('ncm', searchTerm.trim());

      const response = await axios.get(
        `${api.techspdv}/api/cadastro-fiscal/loja/${config.idLoja}/buscar?${params.toString()}&page=${page}&size=20`,
        { headers: { Authorization: `Bearer ${accessToken}` } }
      );

      setCadastros(response.data.content);
      setTotalPages(response.data.totalPages);
      setTotalElements(response.data.totalElements);
    } catch (error) {
      console.error('Erro na busca:', error);
      setCadastros([]);
    } finally {
      setIsLoading(false);
    }
  }, [accessToken, config?.idLoja, searchTerm]);

  const handleSearch = () => {
    loadCadastros(0); // sempre volta para página 1
  };

  const handlePageChange = (page) => {
    loadCadastros(page - 1); // Ant Design usa 1-based
  };

  // ==================== MODAL ====================
  const handleOpenModal = (cadastro = null) => {
    console.log(cadastro);
    setCadastroSelecionado(cadastro);
    setIsModalVisible(true);
  };

  const handleSincronizarTodosProdutos = async () => {
    Modal.confirm({
      title: '⚠️ Sincronização Geral de Cadastro Fiscal',
      icon: <FontAwesomeIcon icon={faSyncAlt} style={{ color: '#faad14' }} />,
      content: (
        <div>
          <p><strong>Esta ação vai atualizar TODOS os produtos da loja</strong> com base nos cadastros fiscais existentes.</p>
          <p>Para cada NCM cadastrado, os impostos, CFOP, CST, etc. serão aplicados em todos os produtos correspondentes.</p>
          <p style={{ color: '#d4380d', fontWeight: 'bold' }}>
            Esta operação pode levar alguns segundos e não pode ser desfeita facilmente.
          </p>
        </div>
      ),
      okText: 'SIM, SINCRONIZAR TUDO',
      cancelText: 'Cancelar',
      okButtonProps: { danger: true, type: 'primary' },

      onOk: async () => {
        const hideLoading = message.loading('Sincronizando todos os produtos com Cadastro Fiscal...', 0);

        try {
          const response = await axiosInstance.post(
            `${api.techspdv}/api/cadastro-fiscal/cadastro-fiscal/sincronizar-todos-produtos`,
            { idLoja: config?.idLoja },
            {
              headers: { Authorization: `Bearer ${accessToken}` }
            }
          );

          const { totalAtualizados, totalNcmsProcessados } = response.data || {};

          hideLoading();

          message.success({
            content: `${totalAtualizados} produtos atualizados com sucesso! (${totalNcmsProcessados} NCMs processados)`,
            duration: 8,
          });

        } catch (error) {
          hideLoading();

          console.error(error);
          message.error(
            error.response?.data?.message ||
            'Erro ao sincronizar os produtos com cadastro fiscal'
          );
        }
      },
    });
  };

  const handleCloseModal = () => {
    setIsModalVisible(false);
    setCadastroSelecionado(null);
    handleSearch(); // recarrega após salvar
  };

  const handleSaved = () => handleCloseModal();

  const renderItem = (item) => (
    <div
      className="card"
      onClick={() => handleOpenModal(item)}
      style={{
        cursor: 'pointer',
        padding: '16px 18px',
        border: '1px solid #e0e0e0',
        borderRadius: '8px',
        backgroundColor: '#fff',
        marginBottom: '12px',
        boxShadow: '0 2px 6px rgba(0,0,0,0.06)'
      }}
    >
      {/* LINHA SUPERIOR: NCM (esquerda) + Descrição (direita) */}
      <div style={{ display: 'flex', justifyContent: 'space-between', marginBottom: '10px' }}>
        <div style={{ fontWeight: 'bold', fontSize: '16px' }}>
          NCM: {item.ncm}
        </div>

        <div style={{
          fontWeight: 'bold',
          textAlign: 'right',
          maxWidth: '55%',
          fontSize: '15px',
          lineHeight: '1.35'
        }}>
          {item.descricao}
        </div>
      </div>

      {/* LINHA INFERIOR: CEST (esquerda) | CFOP + CST (meio) | Alíquotas (direita) */}
      <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', fontWeight: 'bold' }}>

        {/* Esquerda - CEST */}
        <div>
          CEST: {item.cest || '—'}
        </div>

        {/* Centro - CFOP e CST */}
        <div style={{ textAlign: 'center' }}>
          CFOP: {item.cfop || '—'} | CST: {item.cst || '—'} | PIS: {item.cstPis || '—'} | COFINS: {item.cstCofins || '—'}
        </div>

        {/* Direita - Alíquotas */}
        <div style={{ textAlign: 'right' }}>
          ICMS: {item.pIcms || 0}% |
          PIS: {item.pPis || 0}% |
          COFINS: {item.pCofins || 0}%
        </div>
      </div>
    </div>
  );
  return (
    <div className="container-pesquisar">
      <div className="modal-header">
        <Button type="primary" icon={<FontAwesomeIcon icon={faPlus} />} onClick={() => handleOpenModal()}
          style={{ backgroundColor: "black", borderColor: "black" }}>
          Novo Cadastro Fiscal
        </Button>


        <Button
          type="primary"
          icon={<FontAwesomeIcon icon={faSyncAlt} />}
          onClick={handleSincronizarTodosProdutos}
          style={{ backgroundColor: "black", borderColor: "black" }}
        >
          Sincronizar Produtos com Cadastro Fiscal
        </Button>

        <h2>Cadastro Fiscal</h2>
      </div>

      <div className="search-container">
        <input
          className="input"
          type="text"
          placeholder="Buscar por NCM..."
          value={searchTerm}
          onChange={e => setSearchTerm(e.target.value)}
          onKeyPress={(e) => e.key === 'Enter' && handleSearch()}
        />
        <button className="search-button" onClick={handleSearch}>
          Pesquisar
        </button>
      </div>

      {isLoading ? (
        <Spin spinning={isLoading} size="large" tip="Buscando..." />
      ) : (
        <>
          <div className="scroll-container">
            <div className="product-list">
              {cadastros.length > 0 ? (
                cadastros.map(item => <React.Fragment key={item.id}>{renderItem(item)}</React.Fragment>)
              ) : (
                <p className="empty-list-text">
                  {searchTerm ? `Nenhum resultado para "${searchTerm}"` : 'Clique em "Pesquisar" para carregar os cadastros'}
                </p>
              )}
            </div>
          </div>

          {totalPages > 1 && (
            <Pagination
              current={currentPage + 1}
              total={totalElements}
              pageSize={20}
              onChange={handlePageChange}
              style={{ marginTop: 20, textAlign: 'center' }}
            />
          )}
        </>
      )}

      <Modal
        visible={isModalVisible}
        onCancel={handleCloseModal}
        footer={null}
        width="95vw"
        bodyStyle={{ padding: 0 }}
        centered
        destroyOnClose
      >
        <Button type="primary" onClick={handleCloseModal} style={{ backgroundColor: "black", borderColor: "black", margin: '10px' }}>
          Abandonar <FontAwesomeIcon icon={faSignOutAlt} />
        </Button>

        <FormularioDeCadastroFiscal
          onClose={handleCloseModal}
          cadastro={cadastroSelecionado}
          setCadastro={setCadastroSelecionado}
          onSaved={handleSaved}
        />
      </Modal>
    </div>
  );
};

export default CadastroFiscal;